import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader, Tab, Responsive
} from 'semantic-ui-react';
import _ from 'lodash'

import { Link, Redirect } from 'react-router-dom';

import SearchTableData from "../../util/SearchTableData";
import ReactExport from 'react-data-export';
import PaginationFront from "../../util/PaginationFront";
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;


export default class StaffTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.staffList,
            clickedColumn: '',
            column: null,
            direction: null,

            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelData: this.props.staffList.map((el, index) => ([
                { value: (index + 1) + '.' },
                { value: el.firstName },
                { value: el.lastName },
                { value: el.numberOfCourses },
                {
                    value:
                        isNaN(parseFloat(el.averageGradeForStaff)) ||
                            parseFloat(el.averageGradeForStaff).toFixed(2) === '-1.00'
                            ? '-'
                            : parseFloat(el.averageGradeForStaff).toFixed(2)
                }
            ]))
        }

        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.staffList !== this.props.staffList) {
            const updatedData = this.props.staffList || [];

            this.setState({
                data: updatedData,
                excelData: updatedData.map((el, index) => ([
                    { value: (index + 1) + '.' },
                    { value: el.lastName },
                    { value: el.firstName },
                    { value: el.numberOfCourses }
                ])),
                results: [],
            });
        }
    }


    getResults(results) {
        if (results.length === 0) {
            this.setState({
                results: [],
                excelData: this.state.data.map((el, index) => ([
                    { value: (index + 1) + '.' },
                    { value: el.firstName },
                    { value: el.lastName },
                    { value: el.numberOfCourses },
                    {
                        value:
                            isNaN(parseFloat(el.averageGradeForStaff)) ||
                                parseFloat(el.averageGradeForStaff).toFixed(2) === '-1.00'
                                ? '-'
                                : parseFloat(el.averageGradeForStaff).toFixed(2)
                    }
                ]))
            });
        }
        else {
            this.setState({
                results,
                excelData: results.map((el, index) => ([
                    { value: (index + 1) + '.' },
                    { value: el.firstName },
                    { value: el.lastName },
                    { value: el.numberOfCourses },
                    {
                        value:
                            isNaN(parseFloat(el.averageGradeForStaff)) ||
                                parseFloat(el.averageGradeForStaff).toFixed(2) === '-1.00'
                                ? '-'
                                : parseFloat(el.averageGradeForStaff).toFixed(2)
                    }
                ]))
            });
        }
        this.handlePaginationChange({}, { activePage: 1 })
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    handleSort = (clickedColumn) => {
        return () => {
            const { column, direction, data } = this.state;
            if (column !== clickedColumn) {
                this.setState({
                    column: clickedColumn,
                    data: _.sortBy(data, [clickedColumn]),
                    direction: 'ascending',
                })

                return
            }

            this.setState({
                data: data.reverse(),
                direction: direction === 'ascending' ? 'descending' : 'ascending',
            })
        };
    }

    render() {
        let { staffList, errMess } = this.props;
        const data = this.props.staffList;
        const { column, direction } = this.state

        const cleanSheetName = (name) => {
            return name
                ? name.replace(/[\\\/\?\*\[\]\:]/g, '').substring(0, 31)
                : 'Anketa';
        };

        let poll = {};
        try {
            poll = JSON.parse(localStorage.getItem('poll')) || {};
        } catch (e) {
            poll = {};
        }

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'R. br.', width: { wpx: 50 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Broj predmeta', width: { wpx: 120 } },
                    { title: 'Prosječna ocjena', width: { wpx: 120 } },
                ],
                data: this.state.excelData,
            }
        ];
        return (

            <div>


                <Table celled selectable compact sortable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={11} >
                                <Grid column={2} stackable>
                                    <Grid.Column width={14}>
                                        <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['lastName', 'firstName', 'numberOfCourses', 'averageGradeForStaff']} />
                                    </Grid.Column>
                                    <Grid.Column width={2} textAlign="center">
                                        <ExcelFile filename={poll.pollName || 'Anketa'} element={<Popup
                                            trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                <Button.Content visible>
                                                    Excel
                                                </Button.Content>
                                            </Button>}
                                            content="Preuzmi spisak u Excel-u"
                                            hideOnScroll
                                            position="top center"
                                        />}>
                                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name={localStorage.getItem('staffPosition') === 'professor' ? 'Profesori' : 'Asistenti'} />
                                        </ExcelFile>

                                    </Grid.Column>
                                </Grid>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row >
                            <Table.HeaderCell style={{ width: '10px' }} verticalAlign="middle">  R.br. </Table.HeaderCell>
                            <Table.HeaderCell
                                colSpan={2}
                                sorted={column === 'firstName' ? direction : null}
                                onClick={this.handleSort('firstName')}>
                                Ime
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                colSpan={2}
                                sorted={column === 'lastName' ? direction : null}
                                onClick={this.handleSort('lastName')}>
                                Prezime
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                colSpan={2}
                                sorted={column === 'numberOfCourses' ? direction : null}
                                onClick={this.handleSort('numberOfCourses')}>
                                Broj predmeta
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                colSpan={2}
                                sorted={column === 'averageGradeForStaff' ? direction : null}
                                onClick={this.handleSort('averageGradeForStaff')}>
                                Prosječna ocjena
                            </Table.HeaderCell>


                            <Table.HeaderCell colSpan="2" ></Table.HeaderCell>


                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {currentPosts.map((el, index) =>
                        // (<Table.Row
                        //     key={index}
                        //     onClick={(e) => {
                        //         this.setState({ showResults: true });
                        //     }}
                        // >
                        (<Table.Row key={el.id}
                            onClick={(e) => {
                                this.setState({ showResults: true });
                            }}
                        >

                            <Table.Cell style={{ width: '10px' }} verticalAlign="middle">  {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}. </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                {el.firstName}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                {el.lastName}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" width={1} colSpan={2}>
                                {el.numberOfCourses}
                            </Table.Cell>
                            <Table.Cell
                                colSpan={2}
                                verticalAlign="middle"
                                warning={parseFloat(el.averageGradeForStaff).toFixed(2) >= 2 && parseFloat(el.averageGradeForStaff).toFixed(2) <= 4}
                                positive={parseFloat(el.averageGradeForStaff).toFixed(2) > 4}
                                negative={parseFloat(el.averageGradeForStaff).toFixed(2) < 2 && parseFloat(el.averageGradeForStaff).toFixed(2) !== '-1.00'}
                            >
                                {isNaN(el.averageGradeForStaff) ||
                                    parseFloat(el.averageGradeForStaff).toFixed(2) === 'NaN' ||
                                    JSON.stringify(el.averageGradeForStaff) === 'NaN' ||
                                    parseFloat(el.averageGradeForStaff).toFixed(2) === '-1.00'
                                    ? '-' : parseFloat(el.averageGradeForStaff).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell
                                verticalAlign="middle"
                                textAlign="center"
                                colSpan="2"
                            >
                                {/* link */}
                                <Link
                                    onClick={e => { el.numberOfCourses === 0 ? e.preventDefault() : () => { }; }}
                                    to={{
                                        pathname: localStorage.getItem('activeRole').includes('QA admin:') ? '/rezultati/osoblje/predmeti' : '/ankete/osoblje/predmeti',
                                    }}
                                >
                                    <Button
                                        onClick={() => {
                                            localStorage.setItem('organizationalUnitEmployeeId', el.organizationalUnitEmployeeId);
                                            localStorage.setItem('staffName', el.firstName + ' ' + el.lastName);
                                        }}
                                        disabled={el.numberOfCourses === 0}

                                        basic="true"
                                        color="blue"
                                        size="small"
                                    > Predmeti
                                    </Button>

                                </Link>


                            </Table.Cell>
                        </Table.Row>))}
                    </Table.Body>
                </Table>

                {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/Util/StaffTable.js